
import React, { useState, useEffect } from "react";
import { MobileNav } from './MobileNav';
// import { PCHeader } from "./PCHeader";

export const Nav = ({ showNavbar }) => {

    // const screenWidthChange = 768;
    // const [isMobile, setIsMobile] = useState(window.innerWidth <= screenWidthChange);


    // useEffect(() => {
    //     const handleResize = () => {
    //         setIsMobile(window.innerWidth <= screenWidthChange);
    //     };

    //     window.addEventListener('resize', handleResize);

    //     return () => {
    //         window.removeEventListener('resize', handleResize);
    //     };
    // }, []);
    return (
        <div>


            {/* {isMobile ? (
                <MobileNav />
            ) : (
                <PCHeader />
            )} */}

            <MobileNav />



        </div>
    )
}
